import { useEffect, useRef, useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export function useSelectionClearOnUrlChange(
  clearRowSelection: () => void,
  isInitialized = true
) {
  const [searchParams] = useSearchParams();
  const previousParamsRef = useRef<string>("");
  const isFirstRenderRef = useRef(true);

  const getParamsString = useCallback(() => {
    const params = new URLSearchParams(searchParams);
    params.sort();
    return params.toString();
  }, [searchParams]);

  useEffect(() => {
    if (isFirstRenderRef.current || !isInitialized) {
      isFirstRenderRef.current = false;
      previousParamsRef.current = getParamsString();
      return;
    }

    const currentParams = getParamsString();
    if (currentParams !== previousParamsRef.current) {
      clearRowSelection();
      previousParamsRef.current = currentParams;
    }
  }, [getParamsString, clearRowSelection, isInitialized]);
  useEffect(() => {
    return () => {
      isFirstRenderRef.current = true;
    };
  }, []);
}
